<template>
  <v-radio-group
    :value="value"
    @change="onchange"
    :row="$vuetify.breakpoint.mdAndUp ? row : false"
    :disabled="disabled"
    :error-messages="errorsMsg"
    :label="labeltxt"
    hide-details="auto"
  >
    <v-radio v-for="(item, index) in items"
      :key="index"
      :label="item.label"
      :value="item.value"
      :disabled="item.disabled"
    ></v-radio>
    <slot></slot>
    <v-icon class="radioBox-clearBtn" v-if="clearable && !this.isNullOrEmpty(this.value)" @click="handleClear">mdi-close</v-icon>
  </v-radio-group>
</template>

<script>
export default {
  name: 'FormRadioBox',
  props: {
    items: {
      type: [Array],
    },
    value: {
      type: [String, Number, Boolean, Object],
    },
    selectIndex: {
      type: [Number],
    },
    disabled: {
      type: [Boolean],
    },
    clearable: {
      type: [Boolean],
      default() {
        return false;
      },
    },
    row: {
      type: [Boolean],
      default() {
        return false;
      },
    },
    errorsMsg: {
      type: [String, Array],
    },
    labeltxt: {
      type: [String],
    },
  },
  methods: {
    onchange(val) {
      this.$emit('input', val, this.selectIndex);
      this.$emit('doFunction');
    },
    handleClear() {
      this.$emit('input', null);
    },
  },
};
</script>

<style lang="scss" scoped>

.v-input--radio-group.v-input--radio-group--row .v-radio {
  padding-bottom: 4px;
}

::v-deep.v-input--radio-group--row .v-input--radio-group__input
{
  flex-direction: column;
  @include pad-width() {
    flex-direction: row;
  }
}

::v-deep.v-input--radio-group .v-input__control .v-input__slot {
  margin-bottom: 0px;
}

.v-input--selection-controls {
  margin-top: 0px;
  padding-top: 0px;
}

.radioBox-clearBtn {
  margin-bottom: 8px;
  justify-content: flex-start;
}
.radioBox-clearBtn {
  cursor: pointer;
}
</style>
